import React from 'react';
import PropTypes from 'prop-types';
import { toAudString } from 'utils/currency';

export const UpsellsCartTotal = (props) => {
  const { Order } = props;

  return (
    <table
      className="table-css-responsive table-fullwidth cart-table cart-table-seat-review"
      data-testid="upsells-cart-total"
    >
      <tbody>
        <tr className="row-cart-subtotal">
          <td colSpan="4">
            {Order?.Cart?.Fees?.map((fee) => (
              <div className="row">
                <div className="col-sm-6">
                  {fee.Description === 'Online Service Charge' && (
                    <small className="cart-disclaim">
                      Any additional postage charges that may apply will be added when you select
                      your delivery method.
                    </small>
                  )}
                </div>
                <div className="col-sm-4 text-right">
                  <div className="row-heading">{fee.Description}</div>
                </div>
                <div className="col-sm-2 cell-price text-right">{toAudString(fee.Amount)}</div>
              </div>
            ))}
          </td>
        </tr>
        <tr className="row-cart-subtotal">
          <td colSpan="4">
            <div className="row">
              <div className="col-sm-6" />
              <div className="col-sm-4 text-right">
                <div className="row-heading">Cart Total</div>
              </div>
              <div className="col-sm-2 cell-price text-right">{toAudString(Order.OrderTotal)}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

UpsellsCartTotal.propTypes = {
  Order: PropTypes.object,
};
